import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.LandingHeroSection
  }, [_c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.inner
  }, [_c('div', {
    class: _vm.$style.left
  }, [_c('h1', {
    class: _vm.$style.visuallyHidden
  }, [_vm._v("\n          Онлайн-сервис для брокеров по продаже недвижимости по всей России\n        ")]), _vm._v(" "), _c('div', {
    class: _vm.$style.title,
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.$style.description,
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c(_setup.SButton, {
    attrs: {
      "n-link": "",
      "href": "/login",
      "rounded": "",
      "theme": "primary",
      "size": "x-large"
    }
  }, [_vm._v("\n          Войти / Зарегистрироваться\n        ")])], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.right
  }, [_c('div', {
    class: _vm.$style.img
  }, [_c(_setup.ResponsivePicture, {
    attrs: {
      "src-mobile": _setup.mainImg,
      "src-desktop": _setup.mainImg2x
    }
  })], 1)])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };